export const PHONE_SCREEN = 'phone_screen';
export const CALCULATOR_SCREEN = 'calculator_screen';
export const REQUEST_PAYMENT_METHOD = 'payment_method';
export const REQUEST_NEW_CARD = 'new_card';
export const REQUEST_NEW_ACCOUNT = 'new_account';
export const REQUEST_ADDITIONAL_FIELDS = 'additional_fields';
export const REQUEST_DELIVERY_METHODS = 'delivery_methods';

// Libre
export const REQUEST_LIBRE_FLOW = 'request_libre_flow';
export const REQUEST_LIBRE_DISCLAIMER = 'request_libre_disclaimer';
